import React from 'react';
import Star from './Star/Star';
import * as S from './styles';
type HotelCategoryFilterProps = {
  title: string;
  titleInfo?: string;
  filter: any;
  filterKey: string;
  setFilter: any;
  b2c?: boolean;
};
const HotelCategoryFilter: React.FC<HotelCategoryFilterProps> = ({
  title,
  titleInfo,
  filter,
  filterKey,
  setFilter,
  b2c
}) => {
  const stars = [1, 2, 3, 4, 5];
  return <S.Container b2c={b2c}>
      <S.TitleContainer>
        <S.Title>{title}</S.Title>
        {titleInfo && <S.TitleInfo>{`(${titleInfo})`}</S.TitleInfo>}
      </S.TitleContainer>

      <S.Stars>
        {stars.map(star => <Star filter={filter} filterKey={filterKey} setFilter={setFilter} star={star} key={star} dataTestId={`star-${star}`} />)}
      </S.Stars>
    </S.Container>;
};
export default HotelCategoryFilter;